import { useQuery } from '@tanstack/react-query';
import ApiService from '../services/api-service';

import { notification } from 'antd';
import { SaleInfo } from 'src/types/common.types';

const fetchSales = async () => {
  const response = await ApiService.get<SaleInfo[]>('/api/users/sales');
  const data = response.data;
  if (response.status !== 200) {
    notification.error({
      message: 'Không thể lấy danh sách sale',
    });
    throw new Error('Không thể lấy danh sách sale');
  }
  return data;
};

const useSales = () => {
  return useQuery({
    queryKey: ['sales'],
    queryFn: fetchSales,
    staleTime: 1000 * 60 * 5,
  });
};

export default useSales;
